import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import { scroller } from 'react-scroll';
import {SidebarContainer, Icon, CloseIcon, SidebarRoute, SideBtnWrap, SidebarWrapper, SidebarMenu, SidebarLink, RouterSidebarLink} from './SidebarElements'

export const Sidebar = ({isOpen, toggle}) => {
    const location = useLocation();
    const navigate = useNavigate();
    const isHome = location.pathname === "/";

    const navItems = [
        { id: "ACTS", label: "ACTS" },
        { id: "ACRFC", label: "ACRFC" },
        { id: "ACREM", label: "ACREM" },
        { id: "ACRCM", label: "ACRMC" }, // Note: id was ACRMC in original, probably meant ACRCM
        { id: "about", label: "About" },
    ];

    const handleNavClick = (id) => {
        toggle(); // Close sidebar
        if (!isHome) {
            navigate(`/?scrollTo=${id}`);
        } else {
            scroller.scrollTo(id, {
                duration: 500,
                delay: 0,
                smooth: "easeInOutQuart",
            });
        }
    };

    return (
        <SidebarContainer isOpen={isOpen} onClick={toggle}>
            <Icon onClick={toggle}>
                <CloseIcon />
            </Icon>
            <SidebarWrapper>
                <SidebarMenu>
                    {navItems.map((item) => (
                        isHome ? (
                            <SidebarLink 
                                key={item.id}
                                to={item.id} 
                                onClick={toggle}
                                smooth={true}
                                duration={500}
                                spy={true}
                                exact="true"
                                offset={-80}
                            >
                                {item.label}
                            </SidebarLink>
                        ) : (
                            <RouterSidebarLink 
                                key={item.id}
                                onClick={() => handleNavClick(item.id)}
                            >
                                {item.label}
                            </RouterSidebarLink>
                        )
                    ))}
                    <SidebarRoute to="/signup" onClick={toggle} style={{display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '1.4rem', textDecoration: 'none', listStyle: 'none', transition: '0.2s all ease-in-out', color: '#fff', cursor: 'pointer', background: 'transparent', padding: '0'}}>
                        Sign Up
                    </SidebarRoute>
                </SidebarMenu>
                <SideBtnWrap>
                    <SidebarRoute to="/signin" onClick={toggle}>
                        Sign In
                    </SidebarRoute>
                </SideBtnWrap>
            </SidebarWrapper>
        </SidebarContainer>
    )
}